import { render } from "./FormSNNSubsidiesView.vue?vue&type=template&id=174423b1"
import script from "./FormSNNSubsidiesView.vue?vue&type=script&lang=js"
export * from "./FormSNNSubsidiesView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__